var map = {
	"./alfa romeo.svg": "4c55",
	"./audi.svg": "a540",
	"./bmw.svg": "4a88",
	"./byd.svg": "6e8e",
	"./citroen.svg": "bc9a",
	"./cupra.svg": "614a",
	"./dacia.svg": "84fb",
	"./ds.svg": "0f8c",
	"./fiat.svg": "ed15",
	"./ford.svg": "b446",
	"./honda.svg": "0b77",
	"./hyundai.svg": "4bd6",
	"./jaguar.svg": "3d1f",
	"./jeep.svg": "9fc4",
	"./kia.svg": "71cb",
	"./maxus.svg": "e567",
	"./mazda.svg": "e45c",
	"./mercedes-benz.svg": "172b",
	"./mg.svg": "ce7b",
	"./mini.svg": "5e4a",
	"./nissan.svg": "e948",
	"./opel.svg": "4284",
	"./peugeot.svg": "32d6",
	"./polestar.svg": "3dd9",
	"./porsche.svg": "8ac8",
	"./renault.svg": "c059",
	"./seat.svg": "6d7f",
	"./skoda.svg": "cab3",
	"./smart.svg": "0f36",
	"./tesla.svg": "ac73",
	"./volvo.svg": "4b60",
	"./vw.svg": "2d81",
	"./zhidou.svg": "dba0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a9ea";